import { useState } from "react";
import { Globe, User, Search, Menu, X } from "lucide-react";

export default function Header() {
  const [language, setLanguage] = useState("English");
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-[#FAF7EC] py-4">
      <div className="container flex items-center justify-between px-6 mx-auto">
        {/* Бургер-меню для мобильных устройств */}
        <button 
          className="block text-black lg:hidden" 
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Левая часть */}
        <nav className={`absolute lg:static top-16 left-0 w-full lg:w-auto bg-[#FAF7EC] lg:bg-transparent flex flex-col lg:flex-row lg:space-x-6 text-sm font-medium text-black p-4 lg:p-0 ${menuOpen ? "block" : "hidden"} lg:flex`}>
          <a href="#" className="py-2 hover:underline lg:py-0">Care for Planet</a>
          <a href="#" className="py-2 hover:underline lg:py-0">Venues for Hire</a>
          <a href="#" className="py-2 hover:underline lg:py-0">For Schools</a>
        </nav>

        {/* Логотип */}
        <div className="flex-grow text-center lg:flex-grow-0">
          <img src="/logo.svg" className="h-10 mx-auto"/>
        </div>

        {/* Правая часть */}
        <div className="items-center hidden space-x-6 text-sm text-black lg:flex">
          <div className="flex items-center space-x-1 cursor-pointer">
            <Globe size={16} />
            <span>{language}</span>
          </div>
          <div className="flex items-center space-x-1 cursor-pointer">
            <User size={16} />
            <span>Sign in</span>
          </div>
          <div className="flex items-center space-x-1 cursor-pointer">
            <Search size={16} />
            <span>Search</span>
          </div>
        </div>
      </div>

      {/* Дополнительные элементы для мобильных устройств */}
      {menuOpen && (
        <div className="flex flex-col items-center mt-4 space-y-4 text-black lg:hidden">
          <div className="flex items-center space-x-1 cursor-pointer">
            <Globe size={16} />
            <span>{language}</span>
          </div>
          <div className="flex items-center space-x-1 cursor-pointer">
            <User size={16} />
            <span>Sign in</span>
          </div>
          <div className="flex items-center space-x-1 cursor-pointer">
            <Search size={16} />
            <span>Search</span>
          </div>
        </div>
      )}
    </header>
  );
}
